import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import { defineRule } from "vee-validate";
import * as rules from "@vee-validate/rules";
import "bootstrap/dist/css/bootstrap.min.css";
import "v-calendar/dist/style.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import ApiService from "./services/ApiService";
import { clearSession } from "./utils/authStorage";

// Register vee-validate rules (only actual validator functions)
Object.keys(rules).forEach((rule) => {
  if (typeof rules[rule] === "function") {
    defineRule(rule, rules[rule]);
  }
});

// Set up logout callback for when refresh token fails
ApiService.setLogoutCallback(() => {
  clearSession();
  router.push({ name: "login" });
});

const app = createApp(App);

// Global properties (replaces Vue 2 filters)
app.config.globalProperties.$filters = {
  dateformat: function (value) {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "UTC",
    });
  },
};

// Make axios available globally
app.config.globalProperties.$axios = axios;

app.use(router);
app.mount("#app");
